<template>
  <sec-page :faq="FAQS.roadmap.items">
    <sec-hero centered :eyebrow="r.hero.eyebrow" :title="r.hero.title" :lede="r.hero.lede" />

    <sec-section>
      <sec-section-heading :eyebrow="r.levels.eyebrow" :title="r.levels.title" />
      <p class="m500 sec-body" data-reveal>{{ r.levels.intro }}</p>
      <sec-level-chart
        :levels="r.levels.items"
        :total="TOTAL_CONTROLS"
        :unlocks-label="r.levels.unlocksLabel"
        :legend="r.levels.legend"
        :labels="r.levels.labels"
      />
      <p class="m500 sec-body sec-body--muted" data-reveal>{{ r.levels.footnote }}</p>
    </sec-section>

    <sec-section>
      <sec-section-heading :eyebrow="r.domains.eyebrow" :title="r.domains.title" />
      <sec-domain-grid />
    </sec-section>

    <sec-section>
      <sec-section-heading :eyebrow="r.scoring.eyebrow" :title="r.scoring.title" />
      <p v-for="p in r.scoring.paragraphs" :key="p" class="m500 sec-body" data-reveal>{{ p }}</p>
    </sec-section>

    <sec-section>
      <sec-section-heading :eyebrow="r.targets.eyebrow" :title="r.targets.title" />
      <sec-data-table :columns="r.targets.columns" :rows="r.targets.rows" />
      <sec-panel quiet class="roadmap-rules">
        <h3 class="o600 sec-h3 roadmap-rules__lead" data-reveal>{{ r.targets.rules.lead }}</h3>
        <sec-card-grid :items="rules" badge-style="number" min="340px" />
      </sec-panel>
      <sec-actions :actions="r.targets.actions" />
    </sec-section>

    <sec-section labelledby="faq-roadmap" :divider="false">
      <sec-faq
        heading-id="faq-roadmap"
        :eyebrow="FAQS.roadmap.eyebrow"
        :title="FAQS.roadmap.title"
        :items="FAQS.roadmap.items"
      />
    </sec-section>
    <get-in-touch-section heading-id="roadmap-get-in-touch" />
  </sec-page>
</template>

<script setup>
// Secure AI Adoption Maturity Roadmap: five levels across five control domains.
import SecPage from '@/components/security/ui/SecPage.vue';
import SecHero from '@/components/security/ui/SecHero.vue';
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import SecLevelChart from '@/components/security/ui/SecLevelChart.vue';
import SecDomainGrid from '@/components/security/ui/SecDomainGrid.vue';
import SecDataTable from '@/components/security/ui/SecDataTable.vue';
import SecActions from '@/components/security/ui/SecActions.vue';
import SecPanel from '@/components/security/ui/SecPanel.vue';
import SecCardGrid from '@/components/security/ui/SecCardGrid.vue';
import SecFaq from '@/components/security/ui/SecFaq.vue';
import GetInTouchSection from '../shared/GetInTouchSection.vue';
import { ROADMAP } from '@/content/security/roadmap';
import { TOTAL_CONTROLS } from '@/content/security/domains';
import { FAQS } from '@/content/security/faqs';

const r = ROADMAP;
// The two rules of thumb as numbered statement cards (badge 1, 2; same words).
const rules = r.targets.rules.items.map((text, i) => ({ badge: String(i + 1), text }));
</script>

<style scoped>
.sec-panel.roadmap-rules {
  gap: var(--sec-s3);
  padding: var(--sec-s2);
}

.roadmap-rules__lead {
  margin: 0;
  padding-top: var(--sec-s1);
  text-align: center;
}

@media only screen and (min-width: 700px) {
  .sec-panel.roadmap-rules {
    gap: var(--sec-s4);
    padding: 3rem;
  }
}
</style>
